import owned_contract from '../../../../build/contracts/Owned.json'
import token_contract from '../../../../build/contracts/Token.json'
import citizen_contract from '../../../../build/contracts/Citizens.json'
import store from '../../../store'

const contract = require('truffle-contract')

export const INIT_TOKEN = 'INIT_TOKEN'
function tokenUpdated(token) {
    return {
        type: INIT_TOKEN,
        payload: token
    }
}

export function getToken(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let ownerAddress
            let id = 'N-N'
            let totalSupply = 'N-N'
            let balanceOf = 'N-N'
            let buyPrice = 'N-N'
            let sellPrice = 'N-N'
            let buyPriceUsd = 'N-N'
            let symbol = ''
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const OwnedContract = contract(owned_contract)
            OwnedContract.setProvider(web3.currentProvider)
            const TokenContract = contract(token_contract)
            TokenContract.setProvider(web3.currentProvider)
					
            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()

                OwnedContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	
				
                    return cInstance.owner()	
                }).then((result) => {
				
                    ownerAddress = result.toString()
				
                    TokenContract.deployed().then((contractInstance) => {
                        cInstance = contractInstance	
					
                        return cInstance.symbol()	
                    }).then((result) => {
					
                        symbol = result.toString()
                        return cInstance.balanceOf(ownerAddress)
                    }).then((result) => {

                        totalSupply = result.toString()+" "+symbol
                        return cInstance.balanceOf(address)
                    }).then((result) => {

                        balanceOf = result.toString()+" "+symbol
                        return cInstance.buyPrice()
                    }).then((result) => {
					
                        let token = parseFloat(web3.fromWei(result.toString()));
                        buyPrice = token + " ETH"
                        sellPrice = token / 1.2
                        sellPrice += " ETH"
					
                        fetch('https://api.coinmarketcap.com/v1/ticker/ethereum/').then((response) => {
                            if (response.status !== 200) {
                                console.log('There was a problem. Status Code: ' +response.status)
                                return
                            }

                            response.json().then((data) => {
                                let usd = data[0].price_usd
                                let buyPriceUsdNonFormat = token*usd
                                buyPriceUsd = (Math.round(buyPriceUsdNonFormat * 100)/100).toFixed(2) + ' USD'
                                return dispatch(tokenUpdated({"memberId": id,"totalSupply": totalSupply,"balanceOf":balanceOf,"buyPrice":buyPrice,"sellPrice":sellPrice,"buyPriceUsd":buyPriceUsd}))
                            }).catch((err) => {
                                console.log('Fetch Error :-S', err);
                                return dispatch(tokenUpdated({"memberId": id,"totalSupply": totalSupply,"balanceOf":balanceOf,"buyPrice":buyPrice,"sellPrice":sellPrice,"buyPriceUsd":buyPriceUsd}))
                            })
                        }).catch((err) => {
                            console.log('Fetch Error :-S', err);
                            return dispatch(tokenUpdated({"memberId": id,"totalSupply": totalSupply,"balanceOf":balanceOf,"buyPrice":buyPrice,"sellPrice":sellPrice,"buyPriceUsd":buyPriceUsd}))
                        })
					
                    })/*.catch((result) => {
											// If error...
										})*/
				
                })
			
            })
	
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/token/GetToken.js